import { render, staticRenderFns } from "./ModalEditBasicData.vue?vue&type=template&id=ac573e3c"
import script from "./ModalEditBasicData.vue?vue&type=script&lang=js"
export * from "./ModalEditBasicData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports